<template>
  <div class="flex min-h-full flex-col justify-center md:py-12 sm:px-6 lg:px-8 rounded-lg">
    <div class="sm:mx-auto sm:w-full sm:max-w-[610px]">
      <div class="flex flex-col items-center bg-white p-6 md:p-14 m-1 text-center shadow sm:rounded-lg">
        <Icon name="toys_and_games" class="text-primary !text-5xl w-12 !h-12 mt-3" is-filled/>
        <h2 class="mt-6 text-2xl font-medium text-zinc-800">
          {{ __("Well done! You've completed the challenge.") }}
        </h2>

        <div v-if="score !== null" class="mt-4">
          <p class="text-base text-zinc-600 mb-8">
            {{__("Awesome, you did it! You crushed the challenge! Now you can check out your results and see all the great stuff you did, plus a few areas where you can shine even brighter next time." )}}
          </p>
          <div class="bg-success/10 rounded-xl items-center p-4">
            <span class="text-zinc-600 text-2xl">{{ __('Score: ') }} </span>
            <span class="text-zinc-800 text-2xl font-semibold">{{ score }}</span>
          </div>
        </div>
        <div v-else class="mt-4">
          <p class="text-base text-zinc-600">
            {{__("We'll review your submission and notify you of the results shortly.")}}
          </p>
        </div>

        <div class="flex justify-center items-center w-full mt-8 gap-3">
          <button
              v-if="score === null"
              type="button"
              @click="redirectToIndex"
              class="inline-flex items-center px-6 py-2 hover-lift-no-shadow text-gray-700 hover:bg-gray-50 hover:rounded-md transition-colors"
          >
            <Icon name="arrow_back_ios" class="w-5 h-5 text-xl text-zinc-800" />
            {{ __('Back To Challenges') }}
          </button>

          <button
              v-if="score !== null"
              type="button"
              @click="viewResults(challenge, attempt)"
              class="px-6 py-2 rounded-md border-2 transition-colors flex items-center gap-2 bg-none text-primary hover:bg-primary/10 border-primary"
          >
            <span>{{ __('View Results') }}</span>
          </button>

          <button
              v-if="challenge.job"
              type="button"
              @click="handleApplyToJob"
              class="px-6 py-2 rounded-md transition-colors bg-primary text-white hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="alreadyAppliedToJob"
          >
            <span>{{ alreadyAppliedToJob ? __('Already applied to this job') : __('Apply to Job') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/block/icon';
import { __ } from '@/helpers';

const props = defineProps({
  challenge: Object,
  score: {
    type: Number,
    default: null
  },
  attempt: Object,
});

const alreadyAppliedToJob = props.challenge.job?.already_applied ?? false;
function redirectToIndex() {
  window.location.href = route('challenges.index');
}

const redirectToPage = (name, params) => {
  window.location.href = route(name, params);
};

const viewResults = (challenge, attempt) => {
  redirectToPage('redesign.candidate.challenges.results', {
    challenge: challenge.id,
    attempt: attempt.id
  });
};
const handleApplyToJob = () => {
  if (!props.challenge.job) return;

  redirectToPage('redesign.jobs.show', {
    company: props.challenge.company.slug,
    job: props.challenge.job.slug,
  });
};
</script>